<template>
  <v-layout>
    <v-container grid-list-md>
      <v-card>
        <v-card-title class="greyk lighten-4k">
          <h3>Attendance</h3>
        </v-card-title>

        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 sm6>
                   <v-autocomplete label="Class" :items="myclasses" item-text="name" item-value="id" v-model="selected_class" />

          </v-flex>
            <v-flex xs12 sm6>
              <v-dialog
                ref="dialog"
                v-model="modal"
                :return-value.sync="date"
                persistent
                full-width
                width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="date"
                    label="Date"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="date" scrollable>
                  <div class="flex-grow-1"></div>
                  <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
                  <v-btn text color="primary" @click="$refs.dialog.save(date)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12>
              <v-card class="elevation-6">
                <v-card-title>
                  <h4 style="margin:10px">list</h4>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <v-data-table
                    :headers="attendance_headers"
                    :items="c_attendances"
                    class="elevation-0"
                    :search="search"
                    :disable-pagination="true"
                    :loading="aloading"
                  >
                    <template v-slot:items="props">
                      <td class="text-xs-center">{{ props.index + 1 }}</td>
                      <td class="text-xs-center">{{ props.item.s_bio.name }}</td>
                       <td class="text-xs-center">{{ props.item.rollno }}</td>
                      <td class="text-xs-center">
                        <v-radio-group :value="props.item.s_attendance.status" @change="set_as($event,props.index)" row>
                          <v-radio label="Present" :value="1"></v-radio>
                          <v-radio label="Absent" :value="0"></v-radio>
                        </v-radio-group>
                      </td>
                    </template>
                  </v-data-table>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn class="success" @click="saveattendances()">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-container>
  </v-layout>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  layout: "teacher",
  data() {
    return {
      date: new Date().toISOString().substr(0, 10),
      modal: false,
      c_attendances:[],
      search:'',
      selected_class:{},
      attendance_headers: [
        {
          text: "SN",
          align: "center",
          sortable: false,
          value: "level"
        },
        {
          text: "Student",
          align: "center",
          sortable: true,
          value: "name"
        },
        {
          text: "Student ID",
          align: "center",
          sortable: true,
          value: "rollno"
        },
        {
          text: "Status",
          sortable: false,
          value: "status"
        }
      ]
    };
  },
    methods:{

     saveattendances() {

      this.$store.dispatch("attendances/add", {att_date:this.date,class_id:this.selected_class,c_attendances:this.c_attendances});

      if (this.aerrors==null) {
        //this.class_model = this.class_modelcp;
        this.$store.dispatch('responseMessage', {
                type: 'success',
                text: "Attendance saved successfully.",
                title: "Attendance",
                modal: false
            })
      }else{
        this.$store.dispatch('responseMessage', {
                type: 'warning',
                text: "Sorry, attendance could not be saved successfully.",
                title: "Attendance",
                modal: false
            })
      }
    },
    set_as(event,idx){ //set attendance status
      //console.log("poolklklkh",event)
      this.$store.dispatch('attendances/set_as',{idx:idx,status:event})
    },

  },

  computed: {
    ...mapGetters({
      myclasses: "classes/MYCLASSES",
      errors: "classes/CLASS_ERROR",
      loading: "classes/CLASS_LOADING",

      attendances: "attendances/ATTENDANCES",
      aerrors: "attendances/ATTENDANCE_ERROR",
      aloading: "attendances/ATTENDANCE_LOADING",
    }),

  },
  watch:{
    selected_class(val){

       this.$store.dispatch("attendances/getAll",{att_date:this.date,'class_id':val,c_attendances:this.c_attendances});
    //   var data = this.myclasses.find(x=>x.id===val);
    //  // console.log(data)
    //   this.c_attendances = data.students ? data.students : []

    },

    date(val){
        if(this.selected_class){
              this.$store.dispatch("attendances/getAll",{att_date:val,'class_id':this.selected_class});

        }
    },

    attendances(val){
      this.c_attendances = val;
    }

  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/teacher/attendance/attendance.vue